import { create } from "zustand";

export type AskConfirmOptions = {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void | Promise<void>;
};

type ConfirmDeleteState = {
  pending: AskConfirmOptions | null;
  loading: boolean;
  askConfirm: (options: AskConfirmOptions) => void;
  close: () => void;
  confirm: () => Promise<void>;
};

export const useConfirmDeleteStore = create<ConfirmDeleteState>((set, get) => ({
  pending: null,
  loading: false,

  askConfirm: (options) => set({ pending: options }),

  close: () => {
    if (!get().loading) set({ pending: null });
  },

  confirm: async () => {
    const { pending } = get();
    if (!pending) return;
    set({ loading: true });
    try {
      await pending.onConfirm();
      set({ pending: null });
    } finally {
      set({ loading: false });
    }
  },
}));

/** Atalho fora de componentes React. */
export function askDeleteConfirm(options: AskConfirmOptions) {
  useConfirmDeleteStore.getState().askConfirm(options);
}
